import { autopilotHeartbeatView, type AutopilotHeartbeatRow, type AutopilotRoundRow } from '@brunel/shared';
import '../roadmap-autopilot.css';

/** What the browser could read of the Overseer heartbeat; null when it could not be read. */
export interface AutopilotHeartbeatRead {
  readonly heartbeat: AutopilotHeartbeatRow | null;
  readonly latestRound: AutopilotRoundRow | null;
}

function clockTime(iso: string): string {
  const at = new Date(iso);
  return Number.isFinite(at.getTime()) ? at.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'Unknown';
}

/** Beside the Autopilot chip: the heartbeat's truthful last and next round, paused or running. */
export function AutopilotHeartbeatStatus({ read, nowMs }: {
  readonly read: AutopilotHeartbeatRead | null;
  readonly nowMs: number;
}) {
  const view = autopilotHeartbeatView({
    heartbeat: read?.heartbeat ?? null, latestRound: read?.latestRound ?? null, nowMs, time: clockTime,
  });
  return (
    <span className={`autopilot-heartbeat state-${view.state}`} data-heartbeat-state={view.state} title={view.detail} role="status">
      {view.last === null ? 'Heartbeat Unknown' : `${view.last} · ${view.next}`}
    </span>
  );
}
